import React from "react";

import cx from "../ui/cx";
import { formatQty } from "../../static/materialLine";
import { stockTextClass } from "../../static/materialStock";

const chipClass =
  "inline-flex min-w-[2.5rem] justify-center rounded-md border border-gray-200 px-2 text-xs font-semibold leading-5 tabular-nums shadow-sm";

// The chip's background, behind stockTextClass: light red below zero, light grey at zero.
const stockTintClass = (stock: number) =>
  stock < 0 ? "bg-red-50" : stock === 0 ? "bg-gray-50" : "bg-white";

type Props = {
  // The material's bars in stock (totalStock); a dash when there is none to show.
  stock: number | undefined;
};

// A material's bars in stock as a display-only chip: red below zero, grey at zero.
const StockChip = ({ stock }: Props) =>
  stock === undefined ? (
    <span className="text-gray-500">-</span>
  ) : (
    <span
      className={cx(chipClass, stockTextClass(stock), stockTintClass(stock))}
    >
      {formatQty(stock)}
    </span>
  );

export default StockChip;
